<template lang="jade" src="../_partials/input.jade"></template>
<script>
  import inputs from '../_shared/traits'
  import _ from 'lodash'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: ''
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce: val => val.editable ? val : _.set(val, 'field', false)
      }
    },
    methods: {
      isFloat (n) {
        return n.toString().indexOf('.') !== -1
      }
    },

    ready () {
      this.formInput = this.fdata.value
    }
  }
</script>



// WEBPACK FOOTER //
// number.vue?fa0158fa